import { Dispatch, SetStateAction, useState } from "react";

import { PublicationListSearchFilterType } from "@/components/business/PublicationListContainer/publicationList.types";
import SearchInput from "@atoms/SearchInput/SearchInput";
import { usePublicationListFilterState } from "@stores/publicationList";

import PublicationSearchFilterSelect from "./components/PublicationSearchFilterSelect/PublicationSearchFilterSelect";
import {
  PUBLICATION_LIST_INFO_FILTER,
  PUBLICATION_LIST_PRESS_INFO_FILTER_KEY,
} from "./constants/infoFilter.constants";
import * as S from "./PublicationInfoSearch.style";

interface Props {
  currentPressFilter: PublicationListSearchFilterType;
  setCurrentFilter: Dispatch<SetStateAction<PublicationListSearchFilterType>>;
}

const PublicationInfoSearch = ({
  currentPressFilter,
  setCurrentFilter,
}: Props) => {
  const [publicationListFilter, setPublicationListFilter] =
    usePublicationListFilterState();
  const [typing, setTyping] = useState("");

  const { search } = publicationListFilter;

  const handleSearchKeyboard = () => {
    const currentInput = typing.trim();

    const newSearch = { ...search };
    PUBLICATION_LIST_PRESS_INFO_FILTER_KEY.forEach(
      (key) => delete newSearch[key],
    );
    newSearch[currentPressFilter.key] = currentInput;

    if (currentInput) {
      setPublicationListFilter({
        ...publicationListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  const handleSearchButton = () => {
    const currentInput = typing.trim();

    if (currentInput) {
      const newSearch = { ...search };
      PUBLICATION_LIST_PRESS_INFO_FILTER_KEY.forEach(
        (key) => delete newSearch[key],
      );
      newSearch[currentPressFilter.key] = currentInput;

      setPublicationListFilter({
        ...publicationListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  return (
    <S.InfoSearchWrapper>
      <PublicationSearchFilterSelect
        subTitle="Info Filter"
        filterList={PUBLICATION_LIST_INFO_FILTER}
        currentFilter={currentPressFilter}
        setCurrentFilter={setCurrentFilter}
      />
      <S.InfoSearchTitle>
        <SearchInput
          placeholder="Enter text for Publication Information search"
          onSearchButton={handleSearchButton}
          handleSearchKeyboard={handleSearchKeyboard}
          typing={typing}
          setTyping={setTyping}
          widthResize
        />
      </S.InfoSearchTitle>
    </S.InfoSearchWrapper>
  );
};

export default PublicationInfoSearch;
